import { CustomCard, CustomCollapsible } from '@/components';
import { InlineGrid, SkeletonBodyText, SkeletonDisplayText } from '@shopify/polaris';
import ChooseTheme from './components/ChooseTheme';
import Style from './components/Style';
import { useSelector } from 'react-redux';
import { trackingPageIsLoadingSelector } from '@/redux/features/trackingPage.slice';

const configLeftContent = [
  {
    title: 'Choose Theme',
    content: <ChooseTheme />,
  },
  {
    title: 'Style',
    content: <Style />,
  },
];

const LookAndFeel = () => {
  const isLoading = useSelector(trackingPageIsLoadingSelector);

  return (
    <CustomCard title="Look & Feel">
      {isLoading ? (
        <InlineGrid columns={{ xl: 2, lg: 2, md: 2, xs: 1, sm: 1 }} gap="800">
          <div>
            <div>
              <div className="mt-16">
                <SkeletonDisplayText size="small" />
              </div>
              <div className="mt-16">
                <SkeletonBodyText lines={8} />
              </div>
            </div>
            <div className="mt-16">
              <div className="mt-16">
                <SkeletonDisplayText size="small" />
              </div>
              <div className="mt-16">
                <SkeletonBodyText lines={8} />
              </div>
            </div>
            <div className="mt-16">
              <div className="mt-16">
                <SkeletonDisplayText size="small" />
              </div>
              <div className="mt-16">
                <SkeletonBodyText lines={8} />
              </div>
            </div>
            <div className="mt-16">
              <div className="mt-16">
                <SkeletonDisplayText size="small" />
              </div>
              <div className="mt-16">
                <SkeletonBodyText lines={8} />
              </div>
            </div>
          </div>
          <div>
            <div>
              <div>
                <SkeletonDisplayText size="small" />
              </div>
              <div className="mt-16">
                <SkeletonBodyText lines={20} />
              </div>
            </div>
          </div>
        </InlineGrid>
      ) : (
        <>
          <InlineGrid columns={{ xl: 1, lg: 1, md: 1, xs: 1, sm: 1 }} gap="800">
            <div>
              {configLeftContent.map((item, index) => {
                return (
                  <CustomCollapsible open={item.title !== 'Choose Theme'} key={index} title={item.title}>
                    {item.content}
                  </CustomCollapsible>
                );
              })}
            </div>
          </InlineGrid>
        </>
      )}
    </CustomCard>
  );
};
export default LookAndFeel;
